
import React from 'react';
import { SuperAdminHomepage } from './SuperAdminHomepage';
import { MemberLandingPage } from './MemberLandingPage';
import { useAuth } from '@/contexts/AuthContext';

interface Profile {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
}

interface HomepageRouterProps {
  profile: Profile;
}

export const HomepageRouter = ({ profile }: HomepageRouterProps) => {
  const { isImpersonating, effectiveRole } = useAuth();
  
  if (!profile) return null;

  // When impersonating, show the dashboard based on the impersonated user's role
  // When not impersonating, show the dashboard based on the actual user's role
  

  // Only show SuperAdmin dashboard if user is actually a superadmin AND not impersonating
  if (effectiveRole === 'superadmin' && !isImpersonating) {
    return <SuperAdminHomepage profile={profile} />;
  }

  // All other cases (members, or impersonating anyone) show member dashboard
  return <MemberLandingPage profile={profile} />;
};
